import React, { useState } from "react";
import { useLocation } from "react-router-dom";

export default function DropDownSidebarItems({ label, icon, children }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  const location = useLocation();
  const sidebarItems = React.Children.toArray(children);
  const isCurrentLocation = sidebarItems.some((sidebarItem) => {
    return sidebarItem.props.goToPath === location.pathname;
  })

  return (
    <li className={isCurrentLocation ? "active" : ""}>
      <a
        href="#"
        aria-expanded={isOpen ? "true" : "false"}
        className={"prevent-select allow-pointer-cursor"}
        onClick={(e) => handleOpen(e)}
      >
        <i className={`color-blanco-megatone ${icon}`} />
        <span title={label} className="color-blanco-megatone hide-menu">{label}</span>
      </a>
      {isOpen && <ul className="background-gris-megatone">{children}</ul>}
    </li>
  );
};